import { reportApi } from '../http/httpClient'

export interface ReportReferral {
  name: string
  email: string
  cpf: string
  phone: string
  createdAt: string
  registered: boolean
}

export interface ReportReferralResponse {
  referrals: ReportReferral[]
  pagination: {
    skip: number
    limit: number
    sort: string
    total: number
  }
}

export interface ReportReferralParams {
  search?: string
  startDate?: string
  endDate?: string
  maxValue?: string
  minValue?: string
  minSales?: string
  maxSales?: string
  limit?: number
  skip?: number
  sort?: string
}

export async function reportReferrals(
  params?: ReportReferralParams | undefined,
) {
  const { data } = await reportApi.get<ReportReferralResponse>(
    '/report/referrals',
    {
      params,
    },
  )

  return data
}
